module.exports = __webpack_public_path__ + "358da0375d84b331f3a794936fecbd0c.jpg";